import { ApiRequest } from 'src/helpers';
import { API_END_POINTS } from 'src/constants';

export function createMandate(params) {
  return ApiRequest.fetch({
    method: 'post',
    url: `${API_END_POINTS.ZWITCH_MANDATE}/update_or_create`,
    data: params,
  }).then((response) => response.data);
}

export function fetchMandate({ id }) {
  return ApiRequest.fetch({
    method: 'get',
    url: `${API_END_POINTS.ZWITCH_MANDATE}/${id}`    
  }).then((response) => response.data);
}
